export default function(phone) {
  const num = phone || '';
  if (num.slice(0, 1) === '+') {
    return num
      .slice(2)
      .replace(/[^0-9]/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  if (num.length === 11) {
    return num
      .slice(1)
      .replace(/[^0-9]/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  return num.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}



// WEBPACK FOOTER //
// ./client/utils/phone.js